<template>
    <div class="flex mt-3">
        <div class="py-1 px-4 cursor-pointer mr-2 font-bold"
             :class="[active == 'detail' ? 'text-im-black-232323 border-b-2 border-im-black-232323' : 'text-im-gray-767676']"
             @click="clickTab('detail')">
            {{lbl.iimmpact.detail.detail}}
        </div>
        <div class="py-1 px-4 cursor-pointer font-bold"
             :class="[active == 'condition' ? 'text-im-black-232323 border-b-2 border-im-black-232323' : 'text-im-gray-767676']"
             @click="clickTab('condition')">
            {{lbl.iimmpact.detail.condition}}
        </div>
    </div>
    <div class="pt-3 text-14 text-im-gray-767676">
        <div v-show="active == 'detail'" v-html="detailText"></div>
        <div v-show="active == 'condition'" v-html="conditionText"></div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
//Feature
import { useLocale } from '@/feature/LocaleFeature'

export default {
    setup: function() {
        const { lbl } = useLocale()

        return {
            lbl
        }
    },
    name: "DetailAndCondition",
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            active: 'detail', // detail, condition

            detailText: null,
            conditionText: null,
        };
    },
    created: function() {
        this.detailText = Util.newLineToBr(this.campaign.detail);
        this.conditionText = Util.newLineToBr(this.campaign.condition);
    },
    methods: {
        clickTab: function(active) {
            this.active = active;
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
